module.exports = __webpack_public_path__ + "assets/visa_icon-5b26f4.svg";